import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { CalculatingSpinner } from 'components/UI';
import { FunctionComponent } from 'react';
import styles from './ResumeLine.module.css';

export interface ResumeLineProps {
    description: string;
    value: string;
    icon?: IconDefinition;
    loading?: boolean;
    className?: string;
    onIconClick?: () => void;
}

export const ResumeLine: FunctionComponent<ResumeLineProps> = props => {
    const clickHandler = () => {
        !props.loading && props.onIconClick && props.onIconClick();
    };

    return (
        <div className={clsx(styles.container, props.className)}>
            <div className={styles.leftContainer}>
                <span className={styles.text}>{props.description}</span>
                {props.icon && (
                    <FontAwesomeIcon
                        icon={props.icon}
                        fontSize={16}
                        className={styles.icon}
                        onClick={clickHandler}
                    />
                )}
            </div>
            <div className={styles.rightContainer}>
                {props.loading ? <CalculatingSpinner /> : <span className={styles.text}>{props.value}</span>}
            </div>
        </div>
    );
};

export default ResumeLine;
